import React, { Fragment } from 'react';
import './AreaDetail.scss';
import AreaDetail from './AreaDetail';
import StateDetail from './StateDetail';
function AreaDetailMobile({
  currentState,
  setSavedData,
  savedData,
  checked,
  setChecked,
  checkbox,
  setShowAreaDetail,
  setSavedDataArray,
  currentStateName,
  setCurrentState,
  handleClickNavButtons,
  buttonActive
}) {
  return (
    <section className="areaDetailMobile mobile-only">
      {currentState !== null ? (
        <>
          <div className="areaDetailMobile__header">
            <p className="areaDetailMobile__name">{currentStateName}</p>
            <p
              className="areaDetailMobile__close"
              onClick={() => {
                setCurrentState(null);
                handleClickNavButtons(buttonActive);
              }}
            >
              X
            </p>
          </div>
          {currentStateName === 'Alaska' ||
          currentStateName === 'Montana' ||
          currentStateName === 'Wyoming' ? (
            <StateDetail currentStateName={currentStateName} />
          ) : (
            <></>
          )}

          {currentState.map((area, index) => {
            return (
              <Fragment key={index}>
                <AreaDetail
                  currentClickedArea={area}
                  setSavedData={setSavedData}
                  savedData={savedData}
                  checked={checked}
                  setChecked={setChecked}
                  checkbox={checkbox}
                  setShowAreaDetail={setShowAreaDetail}
                  setSavedDataArray={setSavedDataArray}
                />
              </Fragment>
            );
          })}
        </>
      ) : (
        <></>
      )}
    </section>
  );
}

export default AreaDetailMobile;
